// Presentation data for the plan picker page (the screen a new studio owner lands on
// after signing up). Kept out of the component so it can be unit tested without a
// redux store, and so the copy lives in one obvious place.
//
// Andrew approved this page on 2026-09-15 from the mockup in card
// subscription-page-mockup, and answered the two open questions on it the same evening.

// The plan singled out on the page. Matched case-insensitively on the plan name so a
// rename in the admin screen does not silently move the badge to the wrong card.
export const MOST_POPULAR_PLAN = 'Premium';

export const isMostPopular = (subscriptionName) =>
    typeof subscriptionName === 'string' &&
    subscriptionName.trim().toLowerCase() === MOST_POPULAR_PLAN.toLowerCase();

// Shown once, under all three cards, instead of repeating inside every card. Every
// item here was checked against the code on 2026-09-15 before being claimed in front
// of a paying customer.
export const EVERY_PLAN_INCLUDES = [
    'drag and drop builder',
    'unlimited schedules',
    'customization',
    'teacher availability',
    'colour coding and filters',
    'student roster and overlap detection',
    'PDF export and print',
];

// Already the contact address in the privacy policy and in the transactional emails,
// so it is a real inbox, not a new promise.
export const HELP_EMAIL = 'info@studioshuffle.com';

// The refund promise is real and it is Andrew's, not ours to word. Taken from the
// pricing page on studioshuffle.com, checked 2026-09-15, so the two cannot drift apart:
// "Not the right fit? Email us within 7 days of purchase and we'll refund you in full
// - no questions asked." The window and the fact that it is claimed by email are the
// two parts a customer has to act on, so neither is trimmed for brevity.
export const GUARANTEE_DAYS = 7;
export const GUARANTEE_BEFORE_EMAIL = `Not the right fit? Email us within ${GUARANTEE_DAYS} days of purchase and`;
export const GUARANTEE_AFTER_EMAIL = "we'll refund you in full, no questions asked.";

// No promo code line here, on purpose. Promo codes work (allow_promotion_codes is true
// on both Stripe checkout sessions), and the field lives on Stripe's own checkout page.
// Andrew's call, 2026-09-15: the picker page says nothing about them at all.
